(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-we-install"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.materials-mounting-tab').click(function () {
      var tab_id = $(this).data('tab');

      $('.materials-mounting-tab').removeClass('active');
      $('.mounting-tab-content').removeClass('active');

      $(this).addClass('active');
      $('#' + tab_id).addClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contractors"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    $('.contractors-slider').slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      arrows: false,
      swipe: false,
      slidesToShow: 10,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,

      responsive: [
      {
        breakpoint: 1025,
        settings: {slidesToShow: 7,}
      },
      {
        breakpoint: 800,
        settings: {slidesToShow: 5,}
      },
      {
        breakpoint: 480,
        settings: {slidesToShow: 3,}
      }
    ]

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["division-products"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){

  function initCarousel() {
    if ($(window).width() <= 600) {
      if (!$('.product-wrapper').hasClass('owl-loaded')) {
        $('.product-wrapper').addClass('owl-carousel').owlCarousel({
          items: 2.2,
          margin: 12,
          loop: true,
          dots: true,
          nav: false
        });
      }
    } else {
      if ($('.product-wrapper').hasClass('owl-loaded')) {
        $('.product-wrapper').trigger('destroy.owl.carousel');
        $('.product-wrapper').removeClass('owl-carousel owl-loaded');
        $('.product-wrapper').find('.owl-stage-outer').children().unwrap();
      }
    }
  }

  initCarousel();

  $(window).resize(function(){
    initCarousel();
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["division10_built-bkp"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {

    $('.tabs a').on('click', function (e) {
      e.preventDefault();

      var target = $(this).attr('href');

      // Remove active
      $('.tabs a').removeClass('active');
      $('.tab-pane').removeClass('active');

      // Add active
      $(this).addClass('active');
      $(target).addClass('active');

      // MOBILE IMAGE TOGGLE
      $('.mobile-tab-image').hide();
      $(this).siblings('.mobile-tab-image').show();
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["division10_built"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.tab_title_main').on('click', function (e) {
      e.preventDefault();

      var target = $(this).attr('href');

      // Remove active
      $('.tab_title_main').removeClass('active');
      $('.tab-pane').removeClass('active');
      $('.mobile-tab-image').removeClass('active');

      // Add active
      $(this).addClass('active');
      $(target).addClass('active');

      // Show correct mobile image
      $(this).siblings('.mobile-tab-image').addClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["division10_faq"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // open default active
    $('.faq-item.active .faq-answer').show();

    $('.faq-question').click(function () {
      var parent = $(this).parent();

      if (parent.hasClass('active')) {
        parent.removeClass('active');
        parent.find('.faq-answer').slideUp();
        parent.find('.faq-icon').text('+');
      } else {
        $('.faq-item').removeClass('active');
        $('.faq-answer').slideUp();
        $('.faq-icon').text('+');

        parent.addClass('active');
        parent.find('.faq-answer').slideDown();
        parent.find('.faq-icon').text('−');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-blog"] && !Shopify.designMode) return;
  try {
    
 $(function() {
  var owl = $(".blog-slider");
  owl.owlCarousel({
  items:1,
  loop:true,
  margin:20,
  nav:true,
  dots:false,
  autoplay: true, 
  smartSpeed:1000,
  responsive:{
      0:{items:1.3},
      480:{items:2.3},
      1100:{items:3}
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["installation-services-v2-bkp"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    $("#tabs2").tabs({
      show: { effect: "blind", direction: "right", duration: 300 }
    });
    $( "#accordion2" ).accordion();

    var btn = $('#accordion2 li a');
    var wrapper = $('#accordion2 li');

    $(btn).on('click', function() {
      $(btn).removeClass('active');
      $(btn).parent().find('.addon').removeClass('fadein');
      
      $(this).addClass('active');
      $(this).parent().find('.addon').addClass('fadein');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["installation-services-v2"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    var section = $('.tabs-installation');

    section.find('.tab_title_main').on('click', function (e) {
      var href = $(this).attr('href');

      if (!href || !href.startsWith('#tabs-')) return;

      e.preventDefault();

      var parentLi = $(this).parent();

      section.find('.tab_title_main').removeClass('active');
      section.find('.addon').removeClass('fadein');
      section.find('.accordion_content').removeClass('active');

      $(this).addClass('active');
      parentLi.find('.addon').addClass('fadein');
      section.find(href).addClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["materials-section-bkp"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    $('#tabs').tabs({
      show: { effect: 'blind', direction: 'right', duration: 300 },
    });
    $('#accordion').accordion();

    var btn = $('#accordion li a');
    var wrapper = $('#accordion li');

    $(btn).on('click', function () {
      $(btn).removeClass('active');
      $(btn).parent().find('.addon').removeClass('fadein');

      $(this).addClass('active');
      $(this).parent().find('.addon').addClass('fadein');
    });
  });

  $(function () {
    var owl = $('.material-slider');
    owl.owlCarousel({
      items: 1,
      loop: true,
      margin: 30,
      nav: true,
      dots: false,
      autoplay: true,
      smartSpeed: 1000,
      responsive: {
        0: { items: 1.4 },
        480: { items: 2.4 },
        1100: { items: 3.4 },
      },
    });
  });
  $(function () {
    var owl = $('.material-slider2');
    owl.owlCarousel({
      items: 1,
      loop: true,
      margin: 30,
      nav: true,
      dots: false,
      autoplay: true,
      smartSpeed: 1000,
      responsive: {
        0: { items: 1.4 },
        480: { items: 2.4 },
        1100: { items: 3.4 },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["materials-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    var section = $('.tabs-materials');
    var slidersInitialized = {};

    // INIT SLIDER (ONLY ONCE)
    function initSlider(selector) {
      var $slider = $(selector);
      if (!$slider.length || slidersInitialized[selector]) return;

      $slider.owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots: false,
        autoplay: true,
        smartSpeed: 800,
        responsive: {
          0: { items: 1.6 },
          480: { items: 2.5 },
          768: { items: 3 },
          1100: { items: 3 },
        },
      });

      slidersInitialized[selector] = true;
    }

    // INIT ALL SLIDERS ON LOAD
    initSlider('.material-slider');
    initSlider('.material-slider-mobile1');
    initSlider('.material-slider2');
    initSlider('.material-slider-mobile2');

    // SHOW ACTIVE TAB SLIDER
    function showSlider(tabId) {
      // Remove active from all
      section.find('.owl-carousel').removeClass('active-slider');

      if (tabId === '#tabs-1') {
        $('.material-slider, .material-slider-mobile1').addClass('active-slider');
      } else if (tabId === '#tabs-2') {
        $('.material-slider2, .material-slider-mobile2').addClass('active-slider');
      }

      // Refresh ONLY visible sliders
      section.find('.active-slider').trigger('refresh.owl.carousel');
    }

    // INITIAL STATE
    var firstTab = section.find('.tab_title_main').first();
    var firstHref = firstTab.attr('href');

    firstTab.addClass('active');
    firstTab.next('.addon').addClass('fadein');
    section.find(firstHref).addClass('active');

    showSlider(firstHref);

    // TAB CLICK
    section.find('.tab_title_main').click(function (e) {
      e.preventDefault();
      var href = $(this).attr('href');

      // Remove active
      section.find('.tab_title_main').removeClass('active');
      section.find('.addon').removeClass('fadein');
      section.find('.accordion-right > div').removeClass('active');

      // Activate tab
      $(this).addClass('active');
      $(this).next('.addon').addClass('fadein');
      section.find(href).addClass('active');

      // Switch slider
      showSlider(href);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["options-configurations"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.options-tab').click(function () {
      var tab_id = $(this).data('tab');

      $('.options-tab').removeClass('active');
      $('.options-tab-content').removeClass('active');

      $(this).addClass('active');
      $('#' + tab_id).addClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium_restroom_tabs"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.top-tabs li').click(function () {
      var tab_id = $(this).data('tab');

      $('.top-tabs li').removeClass('active');
      $('.premium_restrooms_tab-content').removeClass('active');

      $(this).addClass('active');
      $('#' + tab_id).addClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid-bkp"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    (function ($) {
      $('.product_tab ul.product_tabs').addClass('active').find('> li:eq(0)').addClass('product_current');
      $('.product_tab ul.product_tabs li a').click(function (g) {
        var tab = $(this).closest('.product_tab'),
          index = $(this).closest('li').index();
        tab.find('ul.product_tabs > li').removeClass('product_current');
        $(this).closest('li').addClass('product_current');
        tab
          .find('.product_tab_content')
          .find('div.product_tabs_item')
          .not('div.product_tabs_item:eq(' + index + ')')
          .slideUp();
        tab
          .find('.product_tab_content')
          .find('div.product_tabs_item:eq(' + index + ')')
          .slideDown();
        g.preventDefault();
      });
    })(jQuery);
  });

  $(function() {
    var owl = $(".product-slider");
    owl.owlCarousel({
    items:1,
    loop:true,
    margin:20,
    height:true,
    nav:true,
    dots:false,
    autoplay: true,
    smartSpeed:1000,
    responsive:{
        0:{items:1.1, margin:10,},
        768:{items:2.2, margin:10,},
        900:{items:3.4}
      }
    });
  });

  // $(document).ready(function () {
  //   $('.product-slider').owlCarousel({
  //     items: 1,
  //     loop: true,
  //     margin: 20,
  //     nav: true,
  //     dots: false,
  //     autoplay: true,
  //     smartSpeed: 1000,
  //     responsive: {
  //       0: { items: 1.1, margin: 10 },
  //       768: { items: 2.2, margin: 10 },
  //       900: { items: 3.4 },
  //     },
  //   });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    (function ($) {
      $('.product_tab ul.product_tabs').addClass('active').find('> li:eq(0)').addClass('product_current');
      $('.product_tab ul.product_tabs li a').click(function (g) {
        var tab = $(this).closest('.product_tab'),
          index = $(this).closest('li').index();
        tab.find('ul.product_tabs > li').removeClass('product_current');
        $(this).closest('li').addClass('product_current');
        tab
          .find('.product_tab_content')
          .find('div.product_tabs_item')
          .not('div.product_tabs_item:eq(' + index + ')')
          .slideUp();
        tab
          .find('.product_tab_content')
          .find('div.product_tabs_item:eq(' + index + ')')
          .slideDown();
        g.preventDefault();
      });
    })(jQuery);
  });

  $(function () {
    var owl = $('.top_seller_slider');
    owl.owlCarousel({
      items: 1,
      loop: true,
      margin: 20,
      height: true,
      nav: true,
      dots: false,
      autoplay: false,
      smartSpeed: 1000,
      responsive: {
        0: { items: 1.1, margin: 10 },
        768: { items: 2.2, margin: 10 },
        900: { items: 3.2 },
      },
    });
  });

  $(function () {
    var owl = $('.new_products_slider');
    owl.owlCarousel({
      items: 1,
      loop: true,
      margin: 20,
      height: true,
      nav: true,
      dots: false,
      autoplay: false,
      smartSpeed: 1000,
      responsive: {
        0: { items: 1.1, margin: 10 },
        768: { items: 2.2, margin: 10 },
        900: { items: 3.2 },
      },
    });
  });

  $(function () {
    var owl = $('.restroom_accessories_slider');
    owl.owlCarousel({
      items: 1,
      loop: true,
      margin: 20,
      height: true,
      nav: true,
      dots: false,
      autoplay: false,
      smartSpeed: 1000,
      responsive: {
        0: { items: 1.1, margin: 10 },
        768: { items: 2.2, margin: 10 },
        900: { items: 3.2 },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protection-solutions"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){

  $('.divsn10_tab').click(function(){
    var tab_id = $(this).data('tab');

    $('.divsn10_tab').removeClass('active');
    $('.divsn10_tab-content').removeClass('active');

    $(this).addClass('active');
    $('#' + tab_id).addClass('active');
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-request"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("QuoteForm");
  if (!form) return;

  let isSubmitting = false; // 🚨 prevent multiple attempts

  form.addEventListener("submit", function(e) {

    if (isSubmitting) {
      e.preventDefault();
      return;
    }

    let isValid = true;

    const name = document.getElementById("name");
    const email = document.getElementById("email");
    const message = document.getElementById("message");
    const phone = form.querySelector('input[name="contact[phone]"]');

    const errorName = document.getElementById("error-name");
    const errorEmail = document.getElementById("error-email");
    const errorMessage = document.getElementById("error-message");
    const errorPhone = document.getElementById("error-phone");

    // Reset
    [errorName, errorEmail, errorMessage, errorPhone].forEach(el => el.textContent = "");
    [name, email, message, phone].forEach(el => el.classList.remove("error"));

    // Validation
    if (!name.value.trim()) {
      errorName.textContent = "Name is required";
      name.classList.add("error");
      isValid = false;
    }

    const emailPattern = /^[^ ]+@[^ ]+\.[a-z]{2,}$/;
    if (!email.value.trim()) {
      errorEmail.textContent = "Email is required";
      email.classList.add("error");
      isValid = false;
    } else if (!email.value.match(emailPattern)) {
      errorEmail.textContent = "Enter valid email";
      email.classList.add("error");
      isValid = false;
    }

    if (!message.value.trim()) {
      errorMessage.textContent = "Project details required";
      message.classList.add("error");
      isValid = false;
    }

    // Phone validation (10 digits only)
const phonePattern = /^[0-9]{10}$/;

if (phone.value.trim()) { // only validate if filled
  if (!phone.value.match(phonePattern)) {
    errorPhone.textContent = "Enter valid 10 digit phone number";
    phone.classList.add("error");
    isValid = false;
  }
}

    // 🚨 STOP submission completely
    if (!isValid) {
      e.preventDefault();
      e.stopImmediatePropagation(); // 🔥 VERY IMPORTANT
      return false;
    }

    // ✅ Allow only ONE valid submit
    isSubmitting = true;
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-tool-bkp"] && !Shopify.designMode) return;
  try {
    
$("document").ready(function(){
  $(".tab-slider--body").hide();
  $(".tab-slider--body:first").show();
});

$(".tab-slider--nav li").click(function() {
  $(".tab-slider--body").hide();
  var activeTab = $(this).attr("rel");
  $("#"+activeTab).fadeIn();
	if($(this).attr("rel") == "tab2"){
		$('.tab-slider--tabs').addClass('slide');
	}else{
		$('.tab-slider--tabs').removeClass('slide');
	}
  $(".tab-slider--nav li").removeClass("active");
  $(this).addClass("active");
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-tool"] && !Shopify.designMode) return;
  try {
    
  $('document').ready(function () {
    $('.tab-slider--body').hide();
    $('.tab-slider--body:first').show();
  });

  $('.tab-slider--nav li').click(function () {
    $('.tab-slider--body').hide();
    var activeTab = $(this).attr('rel');
    $('#' + activeTab).fadeIn();
    if ($(this).attr('rel') == 'tab2') {
      $('.tab-slider--tabs').addClass('slide');
    } else {
      $('.tab-slider--tabs').removeClass('slide');
    }
    $('.tab-slider--nav li').removeClass('active');
    $(this).addClass('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsa-team"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.tab-link').on('click', function () {
      // 1. Remove active class from all buttons and panels
      $('.tab-link').removeClass('active');
      $('.tab-panel').removeClass('active');

      // 2. Add active class to clicked button
      $(this).addClass('active');

      // 3. Show the corresponding panel
      var target = $(this).data('target');
      $('#' + target).addClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    var owl = $('.brands-slider');
    owl.owlCarousel({
      items: 7,
      loop: true,
      margin: 15,
      nav: false,
      dots: false,
      autoplay: true,
      slideTransition: 'linear',
      autoplayTimeout: 2000,
      autoplaySpeed: 2000,
      autoplayHoverPause: true,
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 4,
        },
        1000: {
          items: 7,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    var owl = $('.testimonial_slider');
    owl.owlCarousel({
      items: 1,
      loop: true,
      margin: 25,
      autoHeight: true,
      nav: false,
      dots: true,
      autoplay: false,
      smartSpeed: 1000,
      responsive: {
        0: { items: 1.15, margin: 15 },
        768: { items: 2 },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toilet-partitions-testimonials"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    var owl = $('.partitions_testimonial_slider');
    owl.owlCarousel({
      items: 1,
      loop: true,
      autoHeight: false,
      nav: false,
      dots: true,
      autoplay: false,
      smartSpeed: 1000,
      responsive: {
        0: { items: 1 },
        768: { items: 2, margin: 20 },
        1000: { items: 2, margin: 30 },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
